<script>
  import { setSymbolUrl } from '../../lib/services/set-symbols.js';
  import { inview } from '../../lib/actions/inview.js';

  // A set symbol (VISUALS.md "A set name always comes with its set symbol"),
  // from the one symbol source (services/set-symbols.js), coloured by rarity
  // the way the card prints it: common black, uncommon silver, rare gold,
  // mythic orange-red, special purple.
  // The symbol SVG is one colour, so it is a MASK over a rarity fill; the
  // outer span's drop-shadow gives the metallic ones their dark edge (a
  // filter on the masked element itself would be masked away). With no
  // rarity (a set that is not this card's printing) it is common black.
  // `lazy` holds the symbol's SVG until the symbol has scrolled into view:
  // a long list (the card options' 221 sets of Island) loads only the rows
  // shown.
  /** @type {{ code: string, rarity?: string | null, title?: string, lazy?: boolean }} */
  let { code, rarity = 'common', title = '', lazy = false } = $props();

  // svelte-ignore state_referenced_locally
  let seen = $state(!lazy);
  const url = $derived(seen ? setSymbolUrl(code) : null);

  /** @param {HTMLElement} node */
  function watch(node) {
    return inview(node, () => (seen = true)).destroy;
  }

  const tone = $derived(rarity || 'common');
</script>

<span
  class="edge"
  class:outlined={tone !== 'common'}
  {title}
  aria-hidden={title ? undefined : 'true'}
  {@attach lazy && !seen && watch}
>
  {#if url}
    <span class="glyph {tone}" style:--icon="url('{url}')"></span>
  {:else}
    <span class="glyph-space"></span>
  {/if}
</span>

<style>
  .edge {
    display: inline-flex;
    flex-shrink: 0;
  }
  .edge.outlined {
    filter: drop-shadow(0 0 0.6px #000) drop-shadow(0 0 0.4px #000);
  }
  .glyph,
  .glyph-space {
    width: var(--set-symbol-size, 18px);
    height: var(--set-symbol-size, 18px);
  }
  .glyph {
    -webkit-mask: var(--icon) center / contain no-repeat;
    mask: var(--icon) center / contain no-repeat;
    background: #1a1718;
  }
  .glyph.uncommon {
    background: linear-gradient(135deg, #6f7a85 0%, #dfe7ee 50%, #6f7a85 100%);
  }
  .glyph.rare {
    background: linear-gradient(135deg, #8e7637 0%, #e6c66e 50%, #8e7637 100%);
  }
  .glyph.mythic {
    background: linear-gradient(135deg, #b03718 0%, #f68b1f 50%, #b03718 100%);
  }
  .glyph.special,
  .glyph.bonus {
    background: linear-gradient(135deg, #4a1d5c 0%, #a066b8 50%, #4a1d5c 100%);
  }
</style>
